// Thin indirection over location.reload so callers can be unit-tested
// without monkey-patching the non-configurable `window.location.reload`.
export function reloadPage(): void {
	if (typeof location !== 'undefined') {
		location.reload();
	}
}
